/* =======================================================================
   MenuPage — Pagina Menù completo + Impasti speciali in fondo
   =======================================================================
   I piatti sono definiti in src/data/menu.js.
   Il blocco "Impasti speciali" è definito in src/data/copy.js → sezione "doughs".
   ======================================================================= */
import copy from "@/data/copy";
import MenuSection from "@/components/site/MenuSection";
import Doughs from "@/components/site/Doughs";

export default function MenuPage() {
  return (
    <div data-testid="page-menu" className="pt-24 lg:pt-32">
      <MenuSection copy={copy} />
      <Doughs copy={copy} />
    </div>
  );
}
